"use client";
import {
  generateReactHelpers
} from "./chunk-QTLMVU4C.mjs";

// src/hooks.ts
import { useDropzone } from "@uploadthing/dropzone/react";
export {
  generateReactHelpers,
  useDropzone
};
//# sourceMappingURL=hooks.mjs.map